import React from 'react';
import { CssBaseline, Box, Container, Grid } from '@mui/material';
import Banner from '../Layout/Banner';
import WarDiarySection from './WarDiarySection';

function Trangchu() {
  const url = `${process.env.REACT_APP_STATIC_URL}/uploads/banner/banner_chienky.png`;
  const title = 'CHIẾN KÝ'
  return (
    <Box>
      <CssBaseline />
      <Banner url={url} title={title} />
      <WarDiarySection></WarDiarySection>
    </Box>
  );
}

export default Trangchu;